import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { InsightsService } from 'src/portal/buyerscaddy-api/services/insights.service';

import * as TechStackActions from './insight.actions';

@Injectable()
export class TechStackInsightsEffects {
  loadTechStackInsights$;
  constructor(private actions$: Actions, private insightsService: InsightsService) {

    this.loadTechStackInsights$ = createEffect(() =>
      this.actions$.pipe(
        ofType(TechStackActions.loadTechStackInsights),
        exhaustMap((action) =>
        this.insightsService.getInsightsByTechStack(action.params).pipe(
          map((insights) => TechStackActions.loadTechStackInsightsSuccess({ params: action.params, insights })),
          catchError((error) => of(TechStackActions.loadTechStackInsightsFailure({ error })))
        )
          //this.techStackService.getTechStackInsights(action.params)
        )
      )
    );
  }




}
